<template>
  <div>
    <div class="input-group">
      <div class="input-group-prepend">
        <button class="btn btn-primary" type="button" @click="decrement">
          <i class="fas fa-minus"></i>
        </button>
      </div>
      <input
        type="number"
        class="form-control text-center number-stepper"
        placeholder
        :value="modelValue"
        @input="$emit('update', $event.target.value)"
        v-on="$listeners"
        v-bind="$attrs"
      />
      <div class="input-group-append">
        <button class="btn btn-primary" type="button" @click="increment">
          <i class="fas fa-plus"></i>
        </button>
      </div>
    </div>

    <div class="markers d-flex align-items-center justify-content-between">
      <div class="w-100 text-center">{{label}}</div>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    event: "update"
  },
  watch: {
    value(value) {
      this.modelValue = value;
    }
  },
  props: {
    value: {
      type: [String, Number],
      default: 0
    },
    label: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      modelValue: this.value
    };
  },

  methods: {
    decrement() {
      this.modelValue = +this.modelValue - 1;
      this.$emit("update", this.modelValue);
    },
    increment() {
      this.modelValue = +this.modelValue + 1;
      this.$emit("update", +this.modelValue);
    }
  }
};
</script>

